import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@material-ui/core';
import { useFormik } from 'formik';
import { useCallback, useEffect, useState } from 'react';
import moment from 'moment';
import en from '../../../../lang/en-us';
import { CustomRadio } from '../../../../lib/CustomRadio';
import DatePickerInput from '../../../../lib/DatePicker';
import Form, { InputType } from '../../../../lib/Formik';
import TextInput from '../../../../lib/TextField';
import {
    checkForOnlyAlphabets,
    isAlphaNumeric,
    MAX_LENGTH_FOR_PAN,
    MAX_LENGTH_FOR_NOMINEE_NAME,
    MAX_LENGTH_FOR_GUARDIAN_NAME,
    MAX_LENGTH_FOR_ADDRESS,
    minDateForCalender,
    _minDateForCalender,
    panRegex,
    EIGHTEEN_YEARS_IN_MILLISECONDS,
} from '../../../../utils/constants';
import { getNameIndex } from '../CorrectionFolios/correction-folios-selection';
import { initialValues, NOMINEEINFO } from './update-nominee-edit';
import { IdType, nomineeValidationSchema } from './schema';
import { CheckBoxField } from '../../../../lib/CheckBoxField';
import { useDispatch } from 'react-redux';
import { getCountries } from '../../../../redux-store/actions/link';
import { toLower, values } from 'lodash';
import { validate } from 'compare-versions';
const { dashboard, common } = en;

type Countries = {
    name: string;
    dial_code: string;
    code: string;
};

export const kfinRelations = [
    'Wife',
    'Father',
    'Mother',
    'Brother',
    'Sister',
    'Son',
    'Daughter',
    'Husband',
    'Aunt',
    'Friend',
    'Grand Father',
    'Grand Mother',
    'Nephew',
];

export const camsRelations = [
    'Father',
    'Mother',
    'Aunt',
    'Brother-in-law',
    'Brother',
    'Daughter',
    'Daughter-in-law',
    'Father-in-law',
    'Grand Daughter',
    'Grand Father',
    'Grand Mother',
    'Grand Son',
    'Mother-in-law',
    'Nephew',
    'Niece',
    'Sister-in-law',
    'Son',
    'Son-in-law',
    'Spouse',
    'Uncle',
    'Others',
];

function AddNominee(props: any) {
    const { formik, isKfin } = props;
    const thisYear = new Date().getFullYear();

    const resetFieldError = (fieldName: string) => {
        const { [fieldName]: excldeKey, ...rest } = formik.errors;
        formik.setErrors(rest);
    };

    console.log(formik.values, 'formik');

    const dispatch = useDispatch();

    const [countries, setCountries] = useState<Countries[]>([]);

    useEffect(() => {
        async function callApi() {
            const {
                body: { countries },
            } = await getCountries({})(dispatch);
            setCountries(countries);
        }
        callApi();
    }, []);

    return (
        <>
            <div className="edit-add-nominee">
                <h3>
                    {' '}
                    <img src="/images/family-icon.svg" alt="icon" />
                    {getNameIndex(props.index)} {dashboard.UpdateNominee.nomineeText}
                </h3>
                <a onClick={formik.handleSubmit} className="save-nominee">
                    {dashboard.UpdateNominee.save}
                </a>
                {/* <a onClick={() => formik.resetForm()} className="clear-nominee">
                    {dashboard.UpdateNominee.clear}
                </a> */}
                <a
                    onClick={() => props.cancelFormSubmission(props.index - 1, formik.values.id)}
                    className="clear-nominee"
                >
                    {dashboard.UpdateNominee.cancel}
                </a>
                <div className="edit-add-nominee-inner">
                    <div className="nominee-fields">
                        <div className="nominee-fields-single">
                            <div className="nct-select">
                                <FormControl variant="outlined" error={!!formik.errors.relation}>
                                    <InputLabel id="relation-label">Relation</InputLabel>
                                    <Select
                                        labelId="portfolio-sortby-label"
                                        id="portfolio-sortby"
                                        name={'relation'}
                                        value={
                                            formik.values.relation ||
                                            dashboard.UpdateNominee.selectRelation
                                        }
                                        onChange={(e) => {
                                            resetFieldError('relation');
                                            props.handleNomineeChange(
                                                'relation',
                                                e.target.value,
                                                props.index - 1,
                                            );
                                        }}
                                    >
                                        <MenuItem value={dashboard.UpdateNominee.selectRelation}>
                                            {dashboard.UpdateNominee.selectRelation}
                                        </MenuItem>
                                        {(isKfin ? kfinRelations : camsRelations).map(
                                            (relation) => (
                                                <MenuItem value={relation} key={relation}>
                                                    {relation}
                                                </MenuItem>
                                            ),
                                        )}
                                    </Select>
                                    <FormHelperText
                                        className={formik.errors.relation ? 'error' : ''}
                                    >
                                        {formik.errors.relation}
                                    </FormHelperText>
                                </FormControl>
                            </div>
                        </div>
                        <div className="nominee-fields-single">
                            <TextInput
                                label="Name"
                                variant="outlined"
                                value={formik.values.name}
                                name={'name'}
                                onChange={(e) => {
                                    resetFieldError('name');
                                    checkForOnlyAlphabets(e.target.value)
                                        ? props.handleNomineeChange(
                                              'name',
                                              e.target.value,
                                              props.index - 1,
                                          )
                                        : null;
                                }}
                                error={!!formik.errors.name}
                                helperText={formik.errors.name}
                            />
                        </div>
                        <div className="nominee-fields-single">
                            <div className="nominee-fields-single">
                                <DatePickerInput
                                    id={'date-picker-dialog'}
                                    label={'Date of birth'}
                                    value={formik.values.dob}
                                    onChange={(date) => {
                                        resetFieldError('dob');
                                        props.handleNomineeChange('dob', date, props.index - 1);
                                    }}
                                    minDate={_minDateForCalender()}
                                    error={!!formik.errors.dob}
                                    helperText={formik.errors.dob}
                                />
                            </div>
                            <div className="nominee-fields-single nominee-fields-share">
                                <TextInput
                                    label="%(share)"
                                    variant="outlined"
                                    value={formik.values.share}
                                    name={'share'}
                                    onChange={(e) => {
                                        resetFieldError('share');
                                        Number(e.target.value) <= 100
                                            ? props.handleNomineeChange(
                                                  'share',
                                                  e.target.value,
                                                  props.index - 1,
                                              )
                                            : null;
                                    }}
                                    error={!!formik.errors.share}
                                    helperText={formik.errors.share}
                                />
                            </div>
                        </div>
                        <div className="nominee-fields-single">
                            <CustomRadio
                                title="Gender"
                                name={'gender'}
                                selectedValue={formik.values.gender}
                                handleRadioChange={(value: any) => {
                                    resetFieldError('gender');
                                    props.handleNomineeChange('gender', value, props.index - 1);
                                }}
                                list={[
                                    {
                                        label: 'Male',
                                        value: 'male',
                                    },
                                    {
                                        label: 'Female',
                                        value: 'female',
                                    },
                                    {
                                        label: 'Others',
                                        value: 'others',
                                    },
                                ]}
                                key={formik.values.gender}
                                error={!!formik.errors.gender}
                                helperText={formik.errors.gender}
                            />
                        </div>
                        <div className="nominee-fields-single" style={{ marginTop: '20px' }}>
                            <CheckBoxField
                                label={dashboard.UpdateNominee.nomineeFields.addressSameAsFH}
                                value={formik.values.addressSameAsFH === 'Y'}
                                onChange={(e) => {
                                    resetFieldError('addressSameAsFH');
                                    props.handleNomineeChange(
                                        'addressSameAsFH',
                                        e.target.checked ? 'Y' : 'N',
                                        props.index - 1,
                                    );
                                    if (!e.target.checked) {
                                        props.handleNomineeChange('address1', '', props.index - 1);
                                        props.handleNomineeChange('address2', '', props.index - 1);
                                        props.handleNomineeChange('country', '', props.index - 1);
                                        props.handleNomineeChange('city', '', props.index - 1);
                                        props.handleNomineeChange('state', '', props.index - 1);
                                        props.handleNomineeChange('pincode', '', props.index - 1);
                                    } else {
                                        const {
                                            address1,
                                            address2,
                                            country,
                                            city,
                                            state,
                                            pincode,
                                        } = props?.formik?.values?.initialState;
                                        props.handleNomineeChange(
                                            'address1',
                                            address1,
                                            props.index - 1,
                                        );
                                        props.handleNomineeChange(
                                            'address2',
                                            address2,
                                            props.index - 1,
                                        );
                                        props.handleNomineeChange(
                                            'country',
                                            country,
                                            props.index - 1,
                                        );
                                        props.handleNomineeChange('city', city, props.index - 1);
                                        props.handleNomineeChange('state', state, props.index - 1);
                                        props.handleNomineeChange(
                                            'pincode',
                                            pincode,
                                            props.index - 1,
                                        );
                                    }
                                }}
                            />
                        </div>
                        <div className="nominee-fields-single"></div>
                        {formik.values.addressSameAsFH === 'N' && (
                            <>
                                <div className="nominee-fields-single">
                                    <TextInput
                                        label={dashboard.UpdateNominee.nomineeFields.address1}
                                        variant="outlined"
                                        name={'address1'}
                                        value={formik.values.address1}
                                        onChange={(e) => {
                                            resetFieldError('address1');
                                            if (isAlphaNumeric(e.target.value)) {
                                                props.handleNomineeChange(
                                                    'address1',
                                                    e.target.value,
                                                    props.index - 1,
                                                );
                                            }
                                        }}
                                        error={!!formik.errors.address1}
                                        helperText={formik.errors.address1}
                                    />
                                </div>
                                <div className="nominee-fields-single">
                                    <TextInput
                                        label={dashboard.UpdateNominee.nomineeFields.address2}
                                        variant="outlined"
                                        name={'address2'}
                                        value={formik.values.address2}
                                        onChange={(e) => {
                                            resetFieldError('address2');
                                            if (isAlphaNumeric(e.target.value)) {
                                                props.handleNomineeChange(
                                                    'address2',
                                                    e.target.value,
                                                    props.index - 1,
                                                );
                                            }
                                        }}
                                        error={!!formik.errors.address2}
                                        helperText={formik.errors.address2}
                                    />
                                </div>
                                <div className="nominee-fields-single">
                                    <div className="nct-select">
                                        <FormControl
                                            variant="outlined"
                                            error={!!formik.errors.country}
                                        >
                                            <InputLabel id="relation-label">Country</InputLabel>
                                            <Select
                                                labelId="portfolio-sortby-label"
                                                id="portfolio-sortby"
                                                name={'country'}
                                                value={
                                                    formik.values.country ||
                                                    dashboard.UpdateNominee.nomineeFields.country
                                                }
                                                onChange={(e) => {
                                                    resetFieldError('country');
                                                    props.handleNomineeChange(
                                                        'country',
                                                        e.target.value,
                                                        props.index - 1,
                                                    );
                                                    props.handleNomineeChange(
                                                        'pincode',
                                                        '',
                                                        props.index - 1,
                                                    );
                                                }}
                                            >
                                                <MenuItem
                                                    value={
                                                        dashboard.UpdateNominee.nomineeFields
                                                            .country
                                                    }
                                                >
                                                    {dashboard.UpdateNominee.nomineeFields.country}
                                                </MenuItem>
                                                {countries.map((country) => (
                                                    <MenuItem
                                                        value={country.name}
                                                        key={country.code}
                                                    >
                                                        {country.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            <FormHelperText
                                                className={formik.errors.country ? 'error' : ''}
                                            >
                                                {formik.errors.country}
                                            </FormHelperText>
                                        </FormControl>
                                    </div>
                                </div>
                                <div className="nominee-fields-single">
                                    <TextInput
                                        label={dashboard.UpdateNominee.nomineeFields.city}
                                        variant="outlined"
                                        value={formik.values.city}
                                        name={'city'}
                                        onChange={(e) => {
                                            resetFieldError('city');
                                            if (!checkForOnlyAlphabets(e.target.value)) return;
                                            props.handleNomineeChange(
                                                'city',
                                                e.target.value,
                                                props.index - 1,
                                            );
                                        }}
                                        error={!!formik.errors.city}
                                        helperText={formik.errors.city}
                                    />
                                </div>
                                <div className="nominee-fields-single">
                                    <TextInput
                                        label={dashboard.UpdateNominee.nomineeFields.state}
                                        variant="outlined"
                                        value={formik.values.state}
                                        onChange={(e) => {
                                            resetFieldError('state');
                                            if (
                                                !checkForOnlyAlphabets(e.target.value) ||
                                                e.target.value.length > 20
                                            )
                                                return;
                                            props.handleNomineeChange(
                                                'state',
                                                e.target.value,
                                                props.index - 1,
                                            );
                                        }}
                                        name={'state'}
                                        error={!!formik.errors.state}
                                        helperText={formik.errors.state}
                                    />
                                </div>
                                <div className="nominee-fields-single">
                                    <TextInput
                                        label={dashboard.UpdateNominee.nomineeFields.pin}
                                        variant="outlined"
                                        name={'pincode'}
                                        value={formik.values.pincode}
                                        onChange={(e) => {
                                            resetFieldError('pincode');
                                            // allow only one space in non india pincode
                                            const nonIndiaPincodeRegex = /^[A-Za-z0-9]+$/;
                                            const indiaPincodeRegex = /^[0-9]+$/;
                                            const regex =
                                                formik.values.country === 'India'
                                                    ? indiaPincodeRegex
                                                    : nonIndiaPincodeRegex;
                                            const maxLength =
                                                formik.values.country === 'India' ? 6 : 20;
                                            (regex.test(e.target.value) || !e.target.value) &&
                                            e.target.value.length <= maxLength
                                                ? props.handleNomineeChange(
                                                      'pincode',
                                                      e.target.value.toUpperCase(),
                                                      props.index - 1,
                                                  )
                                                : null;
                                        }}
                                        error={formik.errors.pincode ? true : false}
                                        helperText={formik.errors.pincode}
                                    />
                                </div>
                            </>
                        )}

                        <div className="nominee-fields-single">
                            <TextInput
                                label={dashboard.UpdateNominee.nomineeFields.email}
                                variant="outlined"
                                value={formik.values.email}
                                onChange={(e) => {
                                    resetFieldError('email');
                                    props.handleNomineeChange(
                                        'email',
                                        e.target.value,
                                        props.index - 1,
                                    );
                                }}
                                name={'email'}
                                error={!!formik.errors.email}
                                helperText={formik.errors.email}
                            />
                        </div>
                        <div className="nominee-fields-single">
                            <TextInput
                                label={dashboard.UpdateNominee.nomineeFields.mobile}
                                variant="outlined"
                                value={formik.values.mobile}
                                onChange={(e) => {
                                    resetFieldError('mobile');
                                    props.handleNomineeChange(
                                        'mobile',
                                        e.target.value,
                                        props.index - 1,
                                    );
                                }}
                                name={'mobile'}
                                error={!!formik.errors.mobile}
                                helperText={formik.errors.mobile}
                            />
                        </div>

                        <div className="nominee-fields-single">
                            <div className="nct-select">
                                <FormControl variant="filled" error={!!formik.errors.docName}>
                                    <Select
                                        labelId="portfolio-sortby-label"
                                        id="portfolio-sortby"
                                        name={'docName'}
                                        value={
                                            formik.values.docName ||
                                            dashboard.UpdateNominee.nomineeFields.docName
                                        }
                                        onChange={(e) => {
                                            resetFieldError('docName');
                                            props.handleNomineeChange(
                                                'docName',
                                                e.target.value,
                                                props.index - 1,
                                            );
                                            props.handleNomineeChange(
                                                'docValue',
                                                '',
                                                props.index - 1,
                                            );
                                        }}
                                    >
                                        <MenuItem
                                            value={dashboard.UpdateNominee.nomineeFields.docName}
                                        >
                                            {dashboard.UpdateNominee.nomineeFields.docName}
                                        </MenuItem>
                                        <MenuItem value={IdType.Aadhaar}>Aadhaar</MenuItem>
                                        <MenuItem value={IdType.PAN}>PAN</MenuItem>
                                        <MenuItem value={IdType.DrivingLicense}>
                                            Driving License
                                        </MenuItem>
                                        <MenuItem value={IdType.PassportNumber}>
                                            Passport Number
                                        </MenuItem>
                                    </Select>
                                    <FormHelperText
                                        className={formik.errors.docName ? 'error' : ''}
                                    >
                                        {formik.errors.docName}
                                    </FormHelperText>
                                </FormControl>
                            </div>
                        </div>
                        <div className="nominee-fields-single">
                            <TextInput
                                label={
                                    formik.values.docName === IdType.Aadhaar
                                        ? 'Enter last 4 digits of Aadhaar Number'
                                        : formik.values.docName === IdType.PAN
                                        ? 'Enter PAN Number'
                                        : formik.values.docName === IdType.DrivingLicense
                                        ? 'Enter Driving License Number'
                                        : formik.values.docName === IdType.PassportNumber
                                        ? 'Enter Passport Number'
                                        : dashboard.UpdateNominee.nomineeFields.docValue
                                }
                                variant="outlined"
                                value={formik.values.docValue}
                                placeholder={
                                    formik.values.docName === IdType.Aadhaar
                                        ? 'Enter last 4 digits of Aadhaar Number'
                                        : formik.values.docName === IdType.PAN
                                        ? 'Enter PAN Number'
                                        : formik.values.docName === IdType.DrivingLicense
                                        ? 'Enter Driving License Number'
                                        : 'Enter Passport Number'
                                }
                                onChange={(e) => {
                                    resetFieldError('docValue');
                                    props.handleNomineeChange(
                                        'docValue',
                                        e.target.value.toUpperCase(),
                                        props.index - 1,
                                    );
                                }}
                                name={'docValue'}
                                error={!!formik.errors.docValue}
                                helperText={formik.errors.docValue}
                            />
                        </div>
                    </div>
                    {thisYear - new Date(formik.values.dob).getFullYear() < 18 && (
                        <div className="nominee-guardian-details">
                            <h4>{dashboard.UpdateNominee.guardianDetailsHeading}</h4>
                            <div className="nominee-fields">
                                <div className="nominee-fields-single">
                                    <TextInput
                                        label={dashboard.UpdateNominee.guardianName}
                                        variant="outlined"
                                        name={'guardianName'}
                                        value={formik.values.guardianName}
                                        onChange={(e) => {
                                            resetFieldError('guardianName');
                                            checkForOnlyAlphabets(e.target.value)
                                                ? props.handleNomineeChange(
                                                      'guardianName',
                                                      e.target.value,
                                                      props.index - 1,
                                                  )
                                                : null;
                                        }}
                                        error={!!formik.errors.guardianName}
                                        helperText={formik.errors.guardianName}
                                    />
                                </div>
                                <div className="nominee-fields-single">
                                    <TextInput
                                        label={dashboard.UpdateNominee.nomineeFields.guardianPan}
                                        variant="outlined"
                                        name={'guardianPan'}
                                        value={formik.values.guardianPan}
                                        onChange={(e) => {
                                            resetFieldError('guardianPan');
                                            isAlphaNumeric(e.target.value) &&
                                            e.target.value.length <= MAX_LENGTH_FOR_PAN
                                                ? props.handleNomineeChange(
                                                      'guardianPan',
                                                      e.target.value.toUpperCase(),
                                                      props.index - 1,
                                                  )
                                                : null;
                                        }}
                                        error={!!formik.errors.guardianPan}
                                        helperText={formik.errors.guardianPan}
                                    />
                                </div>
                                <div className="nominee-fields-single">
                                    <DatePickerInput
                                        label="Date of Birth"
                                        id={'date-picker-dialog'}
                                        value={formik.values.guardianDob}
                                        name={'guardianDob'}
                                        onChange={(date) => {
                                            resetFieldError('guardianDob');
                                            props.handleNomineeChange(
                                                'guardianDob',
                                                date,
                                                props.index - 1,
                                            );
                                        }}
                                        minDate={minDateForCalender()}
                                        maxDate={moment(new Date()).format('YYYY-MM-DD')}
                                        error={!!formik.errors.guardianDob}
                                        helperText={formik.errors.guardianDob}
                                    />
                                </div>
                                {/* <div className="nominee-fields-single">
                                    <TextInput
                                        label={dashboard.UpdateNominee.nomineeFields.address1}
                                        variant="outlined"
                                        name={'guardianAddress'}
                                        value={formik.values.guardianAddress}
                                        onChange={(e) =>
                                            props.handleNomineeChange(
                                                'guardianAddress',
                                                e.target.value,
                                                props.index - 1,
                                            )
                                        }
                                    />
                                </div> */}
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {/* {props.index < 3 && (
                <div className="add-nominee-btn">
                    <a onClick={props.handleAddNominee}>+ {dashboard.UpdateNominee.addNominee}</a>
                </div>
            )} */}
        </>
    );
}

export default ({ initialValues = {}, ...props }: any) => {
    const validate = (values: NOMINEEINFO) => {
        const nomineeNames = props.nominees
            .map((_ele: NOMINEEINFO, ind: number) => {
                if (ind !== props.index - 1) {
                    return _ele.name.trim().toLowerCase();
                }
            })
            .filter((name: string) => name);

        const nomineePans = props.nominees
            .map((_ele: NOMINEEINFO, ind: number) => {
                if (ind !== props.index - 1) {
                    return _ele.pan.trim().toLowerCase();
                }
            })
            .filter((pan: string) => pan);

        if (nomineeNames.includes(values.name.trim().toLowerCase())) {
            return {
                name: `Nominee name should not be same as other nominee names`,
            };
        } else if (values.name.trim().toLowerCase() === props.investorName.trim().toLowerCase()) {
            return {
                name: `Nominee name can not be investor name`,
            };
        } else if (values.name.trim().length > MAX_LENGTH_FOR_NOMINEE_NAME) {
            return {
                name: `Nominee name should be less than ${MAX_LENGTH_FOR_NOMINEE_NAME} characters`,
            };
        }
        if (values.docName === IdType.PAN) {
            if (values.docValue === props.pan) {
                return {
                    docValue: `Nominee pan should not be the investor pan`,
                };
            } else if (nomineePans.includes(values.docValue?.trim().toLowerCase())) {
                return {
                    docValue: `Nominee pan should not be same as other nominee pans`,
                };
            }
        }
        if (values?.address1?.trim()?.length > MAX_LENGTH_FOR_ADDRESS) {
            return {
                address1: `Address should be less than ${MAX_LENGTH_FOR_ADDRESS} characters`,
            };
        }
        if (values?.address2?.trim()?.length > MAX_LENGTH_FOR_ADDRESS) {
            return {
                address2: `Address should be less than ${MAX_LENGTH_FOR_ADDRESS} characters`,
            };
        }
        if (!values.share?.toString()) {
            return {
                share: 'Share is required',
            };
        } else if (Number(values.share) === 0) {
            return {
                share: 'Nominee share should not be 0',
            };
        }
        if (values.dob) {
            const selectedDate = new Date(values.dob);
            if (selectedDate.getTime() > new Date().getTime()) {
                return {
                    dob: 'Date of birth should not exceed current date',
                };
            }
            const thisYear = new Date().getFullYear();
            const nomineeDobYear = new Date(formik.values.dob).getFullYear();
            if (thisYear - nomineeDobYear < 18) {
                // if (!values.guardianName || values.guardianName.trim().length === 0) {
                //     return {
                //         guardianName: `Guardian name is required`,
                //     };
                // } else if (values.guardianName.trim().length > MAX_LENGTH_FOR_GUARDIAN_NAME) {
                //     return {
                //         guardianName: `Guardian name should be less than ${MAX_LENGTH_FOR_GUARDIAN_NAME} characters`,
                //     };
                // } else if (values.guardianName.toLowerCase() === values.name.toLowerCase()) {
                //     return {
                //         guardianName: `Nominee name and Guardian name should not be same`,
                //     };
                // }
                //if (!values.guardianPan || values.guardianPan.trim().length === 0) {
                //return {
                //guardianPan: `Guardian PAN is required`,
                //};
                //}
                if (values.guardianPan && !panRegex.test(values.guardianPan)) {
                    return {
                        guardianPan: 'Please enter individual pan number',
                    };
                }
                if (
                    values.guardianPan &&
                    (values.guardianPan === values.docValue || values.guardianPan === props.pan)
                ) {
                    return {
                        guardianPan:
                            values.docValue === values.guardianPan
                                ? `Guardian pan should not same as Nominee pan`
                                : `Guardian pan should not same as Investor pan`,
                    };
                }
                if (values.guardianDob && !values.guardianName) {
                    return {
                        guardianName: 'Please enter name of guardian',
                    };
                }
                if (values.guardianDob) {
                    const selectedDate = new Date(values.guardianDob);
                    if (
                        new Date().getTime() - selectedDate.getTime() <
                        EIGHTEEN_YEARS_IN_MILLISECONDS
                    ) {
                        return {
                            guardianDob: 'Guardian of the Nominee should be major',
                        };
                    }
                    if (selectedDate < new Date(minDateForCalender())) {
                        return {
                            guardianDob: common.errors.dob.ageLessThanHundred,
                        };
                    }
                }
            }
        }
    };

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: () => {
            props.saveNominee('isEditable', false, props.index - 1);
        },
        onReset: () => {
            props.handleResetForm(props.index - 1);
        },
        validationSchema: nomineeValidationSchema,
        validateOnChange: false,
        validate: validate,
    });

    const formFields: Partial<InputType>[] = [
        {
            component: AddNominee,
            extraProps: props,
        },
    ];

    useEffect(() => {
        formik.setValues(initialValues, false);
    }, [initialValues]);

    const FormLoad = useCallback(() => {
        return <Form ui={formFields} formik={formik}></Form>;
    }, [formik]);

    return FormLoad();
};
